import MyUtil from './MyUtil';

const ConvertModule = {
  handleNew: (data) => {
    let module = {
      user_group_name: data.user_group_name,
      description: data.description,
      permission: JSON.stringify(data.permission),
    };

    module = MyUtil.clean(module);
    return module;
  },
  handleUpdate: (data) => {
    let module = {
      user_group_id: data.user_group_id,
      user_group_name: data.user_group_name,
      description: data.description,
      permission: JSON.stringify(data.permission),
    };

    module = MyUtil.clean(module);
    return module;
  },
  handleCheck: (state) => {
    const { user_group_name, description, permission } = state;
    const message = [];
    if (!user_group_name) message.push('user_group_name');
    if (!description) message.push('description');
    if (!permission) message.push('permission');
    return message.length > 0 ? message : false;
  },
};

export default ConvertModule;
